import { useEffect, useState } from "react";
import Lenis from "lenis";
import AnnouncementBar from "@/components/AnnouncementBar";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Portfolio from "@/components/Portfolio";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import WhyChooseMe from "@/components/WhyChooseMe";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  const [showBanner, setShowBanner] = useState(
    () => localStorage.getItem("an_dismissed") !== "1"
  );

  const dismissBanner = () => {
    setShowBanner(false);
    localStorage.setItem("an_dismissed", "1");
  };

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    const handleClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const el = document.querySelector(target.getAttribute("href"));
        if (el) lenis.scrollTo(el, { offset: -40 });
      }
    };
    document.addEventListener("click", handleClick);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", handleClick);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <AnnouncementBar visible={showBanner} onClose={dismissBanner} />
      <Navbar topOffset={showBanner ? 40 : 0} />
      <main>
        <Hero />
        <About />
        <Portfolio />
        <Marquee />
        <Services />
        <WhyChooseMe />
        <Pricing />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
